import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  status: string;
  rating: string;
}

interface ParamProps {
  id: number;
}

const prospectMutation = ({ id }: ParamProps) => useMutation({
  mutationKey: ['prospectMutation', id],
  mutationFn: (body: Props) => agent.getClient().patch(`prospect/${id}`, body),
  onSuccess: () => { },
});

export default prospectMutation;
